import { Component, OnInit, computed, inject, signal } from '@angular/core'

import { mobileNavImports as imports } from './mobile-nav.imports'
import { NavigationEnd, Router } from '@angular/router'
import { SLIDE_UP_DOWN } from '@animations/slides.animations'
import { filter, map } from 'rxjs/operators'
import { OperatorDataState } from '@states/operator-data'

@Component({
	selector: 'mobile-nav',
	templateUrl: './mobile-nav.component.html',
	styleUrl: './mobile-nav.component.scss',
	standalone: true,
	imports,
	animations: [SLIDE_UP_DOWN],
})
export class MobileNavComponent implements OnInit {
	readonly #router = inject(Router)
	readonly #operatorDataState = inject(OperatorDataState)
	readonly #route = signal<string>(this.#router.url)

	get #visibleItem(): 'NAV' | 'USER' | null {
		if (this.#route() !== '/') {
			return 'NAV'
		}

		return null
	}

	readonly locationName = computed(() => this.#operatorDataState.metadata()?.locationName ?? '')
	readonly visible = signal<boolean>(false)
	readonly visibleItem = signal<'NAV' | 'USER' | null>(this.#visibleItem)
	readonly options = [
		{
			label: 'Validate',
			path: '/',
		},
		{
			label: 'Request Car',
			path: '/request-car',
		},
		{
			label: 'Overnight Report',
			path: '/overnight-report',
		},
		{
			label: 'Valet Service Monitoring',
			path: '/valet-service-monitoring',
		},
	]

	ngOnInit(): void {
		this.#router.events
			.pipe(
				filter(event => event instanceof NavigationEnd),
				map(event => event as NavigationEnd)
			)
			.subscribe(({ urlAfterRedirects }) => {
				const visibleItem = urlAfterRedirects !== '/' ? 'NAV' : null

				this.visible.update(() => false)
				this.visibleItem.update(() => visibleItem)
			})
	}

	onNavigateToHome(): void {
		this.visible.update(() => false)
		this.visibleItem.update(() => null)
		this.#router.navigate(['/'])
	}

	onShowOptions(): void {
		this.visible.update(() => true)
		this.visibleItem.update(() => 'NAV')
	}

	onShowUser(): void {
		this.visible.update(() => true)
		this.visibleItem.update(() => 'USER')
	}

	signOut(): void {
		globalThis.localStorage.removeItem('userData')

		this.#operatorDataState.operatorData.set(null)
		this.#router.navigate(['/auth/sign-in'])
	}
}
